import {isPng} from "./isPng";

export const getPngChunkData = (
    chunkId: string,
    png: Uint8Array
): DataView => {

    if (!isPng(png)) {
        throw new Error("Given array is not a valid PNG");
    }

    const existingChunkIds = [];

    let offset = 8;
    const view = new DataView(png.buffer);
    while (offset < png.length) {

        const length = view.getUint32(offset);
        const type = new TextDecoder().decode(png.slice(offset + 4, offset + 4 + 4));

        if (type === chunkId) {
            return new DataView(png.buffer, offset + 4 + 4, length);
        }

        offset = offset + length + 12;
        existingChunkIds.push(type);
    }

    throw new Error(`
        Chunk with ID '${chunkId}' does not exist in PNG.
        Chunks that do exist are:\n${existingChunkIds.join(", ")}
    `);
};